import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material';
import { TranslateService } from '@ngx-translate/core';
import { first } from 'rxjs/operators';
import { AuthenticationService } from '../../../@core/services/authentication.service';

export interface ProblemReportLoginData {
  userName: string;
}

@Component({
  selector: 'ngx-problem-report-login-dialog',
  templateUrl: './problem-report-login-dialog.component.html',
  styleUrls: ['./problem-report-login-dialog.component.scss']
})
export class ProblemReportLoginDialogComponent implements OnInit {
  userName = '';
  password = '';
  logging = false;
  errorMessage: string;

  constructor(
    public dialogRef: MatDialogRef<ProblemReportLoginDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: ProblemReportLoginData,
    private authenticationService: AuthenticationService,
    private translate: TranslateService
  ) {}

  ngOnInit(): void {
    this.userName = this.data.userName || localStorage.getItem('lastUserName') || '';
  }

  login(): void {
    if (this.logging || !this.userName || !this.password) { return; }
    this.logging = true;
    this.errorMessage = undefined;
    this.authenticationService.login(this.userName, this.password).pipe(first()).subscribe(
      () => {
        this.logging = false;
        this.password = '';
        this.dialogRef.close(true);
      },
      () => {
        this.logging = false;
        this.password = '';
        this.errorMessage = this.translate.instant('problem-report.reconnect-error');
      }
    );
  }
}
